import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';
import { map } from 'rxjs/operators';

@Injectable()
export class FranchiseService {

  private URL = AppSettings.API_ENDPOINT;

  constructor(private http: HttpClient) {
  }

  // fetch dashboard data
  fetchDashboardData(getSchoolId, academicId, AUTHTOKEN) {
    const params = { getSchoolId, academicId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/dashboard', params, { headers }).pipe(map(res => res));
  }

  // fetch dashboard data
  fetchSchoolListData(getSchoolId, AUTHTOKEN) {
    const params = { getSchoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/schoolList', params, { headers }).pipe(map(res => res));
  }

  fetchFeatureList(schoolId, AUTHTOKEN) {
    const params = { schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/schoolFeatureList', params, { headers }).pipe(map(res => res));
  }

  updateFeatureList(schoolId, pkSchoolFeatureId, ActiveStatus, AUTHTOKEN) {
    const params = { schoolId, pkSchoolFeatureId, ActiveStatus };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/updateSchoolFeature', params, { headers }).pipe(map(res => res));
  }

  // is valid url or its already existing
  isExcitingUrl(domain) {
    const params = { domainName: domain };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/signUp/domainAvailability', params, { headers }).pipe(map(res => res));
  }

  registerSchool(domainName, schoolName, description, state, locality, pincode, address, accountType,
    emailId, password, username, yourName, phoneNumber, country, commissionType, commissionValue, AUTHTOKEN) {
    const params = {
      domainName,
      schoolName,
      description,
      state,
      locality,
      pincode,
      address,
      accountType,
      emailId,
      password,
      username,
      yourName,
      phoneNumber,
      country,
      commissionType,
      commissionValue
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/addSchool', params, {headers}).pipe(map(res => res));
  }

  schoolGraffInfo(year, AUTHTOKEN) {
    const params = { year };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/dashboard/schoolAnalytics', params, { headers }).pipe(map(res => res));
  }

  feesGraffInfo(year, AUTHTOKEN) {
    const params = { year };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/dashboard/feeAnalytics', params, { headers }).pipe(map(res => res));
  }

  studentGraffInfo(year, AUTHTOKEN) {
    const params = { year };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/dashboard/studentAnalytics', params, { headers }).pipe(map(res => res));
  }

  academicYears(AUTHTOKEN) {
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/academicYear', params, { headers }).pipe(map(res => res));
  }


}
